import "./OpenAccountQuizSystemPromptComponent.scss";
import template from "./OpenAccountQuizSystemPromptComponent.html";
import {IComponentOptions, IHttpService, IOnDestroy} from "angular";
import {Observable, ReplaySubject} from "rxjs";
import {IvAccountOpeningService} from "../../../../../account-opening/iv/service/IvAccountOpeningService";
import {CurrentUserService} from "../../../../../services/user/CurrentUserService";
import {Branding} from "../../../../../types/Branding";
import {ClientEventService} from "../../../../../services/client-events/ClientEventService";
import {UserConfig} from "../../../../../types/UserConfig";
import {BackOffice} from "../../../../../types/BackOffice";
import {FxeQuizService} from "../../../../../quiz/fxe/service/FxeQuizService";
import {SwiftOnboardingService} from "../../../../../swift/service/onboarding/SwiftOnboardingService";

export const OpenAccountQuizPrompt = "tfOpenAccountQuizPrompt";

export function openAccountQuizPrompt(): IComponentOptions {
    return {
        template,
        controllerAs: "ctrl",
        controller: OpenAccountQuizSystemPromptComponentController
    };
}

export enum OpenAccountType {
    LINK = "LINK",
    EXTERNAL = "EXTERNAL",
    INTERNAL = "INTERNAL",
}

export class OpenAccountQuizSystemPromptComponentController implements IOnDestroy {

    public readonly isMfaEnabled: boolean;
    public readonly hasPassedQuiz: boolean;
    public readonly hasSwiftApplication: boolean;

    public readonly accountOpeningPath: Observable<string>;
    private readonly openDialog$ = new ReplaySubject<boolean>(1);
    private readonly destroy$ = new ReplaySubject<boolean>(1);

    private readonly isLivePrices: boolean;
    private readonly enableOpenAccountMainSection: boolean;
    private readonly enableDelayedDataSection: boolean;
    private readonly disableDelayedDataBanner: boolean;
    private readonly enableOpenAccountMainSectionBranding: Branding[] = [Branding.ALLFIN, Branding.IV, Branding.TF];
    private readonly delayedDataBannerExcludedBrands: BackOffice[] = [ BackOffice.PHILLIP ];
    private readonly enableDelayedDataBranding: Branding[] = [Branding.OPEN_TRADER, Branding.ALLFIN, Branding.IV, Branding.TF];
    /** @ngInject */
    public constructor(private readonly ivAccountOpeningService: IvAccountOpeningService,
                       private readonly currentUserService: CurrentUserService,
                       private readonly clientEventService: ClientEventService,
                       private readonly fxeQuizService: FxeQuizService,
                       private readonly swiftOnboardingService: SwiftOnboardingService,
                       private readonly userConfig: UserConfig,
                       private readonly $http: IHttpService) {
        this.hasPassedQuiz = this.currentUserService.hasPassedMarginQuiz();
        this.hasSwiftApplication = this.currentUserService.hasSwiftApplication();
        this.isMfaEnabled = userConfig.isMfaEnabled;
        this.isLivePrices = userConfig.livePrices;
        this.enableOpenAccountMainSection = this.enableOpenAccountMainSectionBranding.includes(userConfig.branding);
        this.enableDelayedDataSection = this.enableDelayedDataBranding.includes(userConfig.branding);
        this.disableDelayedDataBanner = this.delayedDataBannerExcludedBrands.includes(userConfig.backOffice);
        this.watchOpenDialog();
    }

    public async openAccountSwift() {
        try {
            if (this.hasSwiftApplication) {
                const id = await this.swiftOnboardingService.getApplicationId();
                if (id) { this.swiftOnboardingService.redirectToSwiftToResume(id); }
            } else {
                const guid = await this.swiftOnboardingService.getGUID();
                if (guid) { this.swiftOnboardingService.redirectToSwift(guid); }
            }
        } catch (e) {
            alert("Could not get application id or guid. Please try again later.");
            console.log(e);
        }

    }

    private watchOpenDialog() {
        this.openDialog$
            .withLatestFrom(this.currentUserService.current)
            .map(([_, user]) => user)
            .takeUntil(this.destroy$)
            .subscribe((user) => {
                // if user is Phillip
                if (this.userConfig.backOffice === BackOffice.PHILLIP) {
                    if (!user.hasPassedMarginQuiz()) {
                        this.takeOptionsQuiz();
                    } else if (!this.userConfig.isMfaEnabled) {
                        this.logout();
                    } else {
                        this.openAccountSwift();
                    }
                } else {
                    console.log ("It is not is Phillip");
                }
            });
    }

    // NOTE: Fxe is only applicable for TF skin with backOffice PHillip
    public async logout() {
        window.location.assign("/tradefloor/oauth2/authorization/tf?promptMfa=true");
    }

    public openAccount() {
        this.openDialog$.next(true);
    }

    public $onDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }

    public async takeOptionsQuiz() {
        await this.fxeQuizService.open();
    }
}
